import { urls } from 'constants/urls';
import { delay, http, HttpResponse } from 'msw';

const featureFlag = [
  http.get(`${process.env.BFF_URL}${urls.flagr.checkFeature}/:featureId`, async () => {
    await delay();
    return HttpResponse.json({ access: true }, { status: 200 });
  }),
];

export { featureFlag };
